<template>
  <div :style="rotateStyle" class="annotation annotationTextarea">
    <textarea class="annotationEl" :id="'annotationTextarea-' + index" @click="showControls" :readonly="readOnly" :style="getStyle" v-model="value"></textarea>
  </div>
</template>

<script>
export default {
  name: 'annotation-textarea',

  mounted () {
    let that = this

    this.setup()

    this.$bus.$on('setFontSize', function (sizeData) {
      if (sizeData.index !== that.index) return
      that.fontSize = sizeData.size
      that.$store.commit('setAnnotationDataKey', {
        index: that.index,
        key: 'fontSize',
        value: that.fontSize
      })
      // that.$store.dispatch('saveAll')
    })

    this.$bus.$on('setReadOnly', function (annotationData) {
      if (annotationData.index === that.index) {
        if (!that.readOnly && annotationData.value) {
          that.$store.commit('setAnnotationData', {
            index: that.index,
            data: {
              fontSize: that.fontSize,
              text: that.value
            }
          })
          // that.$store.dispatch('saveAll')
        }
        that.readOnly = annotationData.value
      }
    })
  },

  data () {
    return {
      fontSize: 10,
      highlight: false,
      readOnly: true,
      value: ''
    }
  },

  props: [
    'index',
    'width',
    'height',
    'rotation',
    'storeData'
  ],

  methods: {
    setup () {
      console.log(JSON.stringify(this.storeData))
      if (Object.keys(this.storeData).length) {
        this.value = this.storeData['text']
        this.fontSize = this.storeData['fontSize']
        console.log('Set fontSize', this.fontSize)
      }
    },

    showControls () {
      const elPos = this.$el.getBoundingClientRect()
      this.$bus.emit('showAnnotationControls', {
        index: this.index,
        type: 'textarea',
        x: elPos.left,
        y: elPos.top + elPos.height
      })
    }
  },

  computed: {
    rotateStyle: function () {
      return 'transform: rotate(' + this.rotation + 'deg);'
    },

    getStyle: function () {
      let style = 'width:' + this.width + 'px;height:' + this.height + 'px;font-size:' + this.fontSize + 'px;'
      if (this.highlight) style += 'border: 2px solid black;'
      return style
    }
  }
}
</script>

<style lang="scss" scoped>
  .annotationTextarea {
    textarea {
      padding: 5px;
      margin: 0;
      display: block;
      resize: none;
      user-select: none;
      border: 1px solid black;
      border-radius: 5px;
      color: #000;

      &:read-only {
        background-color: #A8A8A8;;
        cursor: pointer;

        // Workaround for Chrome/Mozilla bug and expected behavior, blinking cursor still shows on readonly
        // https://bugzilla.mozilla.org/show_bug.cgi?id=396542
        &:focus {
          color: transparent;
          text-shadow: 0 0 0 #000;
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/annotations/AnnotationTextarea.vue